<template>
  <div
    class="offcanvas offcanvas-start text-start"
    tabindex="-1"
    id="offcanvasNavbar"
    aria-labelledby="offcanvasNavbarLabel"
  >
    <div class="offcanvas-header">
      <slot name="header">
        <brand-logo to="/" img-style="height: 36px"></brand-logo>
        <div class="d-flex align-items-center gap-2 ms-auto">
          <div class="d-md-none">
            <data-bs-theme @changeTheme="$emit('changeTheme', $event)"></data-bs-theme>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
      </slot>
    </div>
    <div class="offcanvas-body">
      <slot name="nav-panel"></slot>
      <slot name="footer">
        <language-switcher class="mt-3 mt-md-0 me-0 me-md-3"></language-switcher>
        <login-button></login-button>
      </slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import BrandLogo from "@/components/app/headers/brand-logo.vue";
import DataBsTheme from "./data-bs-theme.vue";
import LanguageSwitcher from "./language-switcher.vue";
import LoginButton from "@/components/app/buttons/login-button.vue";

@Options({
  components: { BrandLogo, DataBsTheme, LanguageSwitcher, LoginButton },
})
class OffCanvasNavbar extends Vue {}
export default OffCanvasNavbar;
</script>
<style lang="scss">
@import "@/assets/styles/bootstrap/variables";
// CSS переменные для темной темы
:root {
  --accent-color: #{$warning};
  --oc-border-015: #{rgba($warning, 0.15)};
  --oc-border-010: #{rgba($warning, 0.1)};
}

[data-bs-theme="dark"] {
  --oc-border-015: #{rgba($warning, 0.15)};
  --oc-border-010: #{rgba($warning, 0.1)};
}

@media (max-width: 1399.98px) {
  #offcanvasNavbar .offcanvas-body {
    display: flex;
    flex-direction: column;
  }

  #offcanvasNavbar .offcanvas-body .navbar-nav {
    flex-grow: 0 !important;
  }

  #offcanvasNavbar .offcanvas-body > .navbar-nav.dropdown {
    width: 100%;
  }

  #offcanvasNavbar .offcanvas-body > .btn {
    width: 100%;
    margin-top: auto;
  }
}

.nav-link {
  font-weight: 500;
  margin: 0 3px;
  padding: 8px 16px !important;
  transition: all 0.3s ease;
  position: relative;
}

#offcanvasNavbar .nav-item {
  display: flex;
  align-items: stretch;
}

#offcanvasNavbar .nav-link {
  display: flex;
  align-items: center;
}

.nav-link:hover,
.nav-link:focus {
  background-color: var(--oc-border-010);
}

.nav-link.active {
  background-color: var(--oc-border-015);
}
/* Анимация для активного пункта меню */
.nav-link::after {
  content: "";
  position: absolute;
  width: 0;
  height: 1px;
  bottom: 0;
  left: 50%;
  background: linear-gradient(
    90deg,
    rgba($secondary, 0) 0%,
    $secondary 50.11%,
    rgba($secondary, 0) 100.21%
  );
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 70%;
}
</style>
